import { render, staticRenderFns } from "./LabelingLevelField.vue?vue&type=template&id=101ff844&scoped=true"
import script from "./LabelingLevelField.vue?vue&type=script&lang=js"
export * from "./LabelingLevelField.vue?vue&type=script&lang=js"
import style0 from "./LabelingLevelField.vue?vue&type=style&index=0&id=101ff844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101ff844",
  null
  
)

export default component.exports